/**
 * Light rays (8): a small circle with eight evenly spaced rays radiating from
 * it — the dimmer member of the light-rays family, reading a touch calmer than
 * its ten-ray sibling.
 *
 * Progress bursts the rays outward and fades them away through the first half
 * of the cycle, then sprouts them back out of the circle through the second.
 * See LightRaysBase for the drawing, the reach, and the motion.
 *
 * Color slots: 0 the circle, 1 the rays.
 */import*as React from"react";import LightRays,{evenlySpacedRayAngles}from"web/shared/icons/glyphs/LightRaysBase";import{jsx as _jsx}from"react/jsx-runtime";const RAY_ANGLES_DEGREES=evenlySpacedRayAngles(8);function LightRays8Glyph(props){return/*#__PURE__*/_jsx(LightRays,{rayAngles:RAY_ANGLES_DEGREES,progress:props.progress,colors:props.colors});}export default LightRays8Glyph;